import Button from 'components/common/Button/Button'
import { DATE_FORMATS } from 'constants/dateTime'
import { isEmpty, isEqual } from 'lodash'
import React, { Component } from 'react'
import T from 'prop-types'
import cn from 'classnames'
import moment from 'moment'
import datePickerLocaleEn from 'date-fns/locale/en-US'
import {
  FormControl,
  Popper,
  Grow,
  Paper,
  TextField,
  InputAdornment,
  Button as MUIButton,
} from '@material-ui/core'
import { connect } from 'react-redux'
import { DateRangePicker } from 'react-date-range'
import { isSameDay, subDays, subMonths, subWeeks } from 'date-fns'
import { injectIntl } from 'react-intl'
import datePickerLocaleEs from 'date-fns/locale/es'
import DateRangeType from 'types/date/DateRange'
import { formatMessage } from 'lib/intl'
import {
  StyledPopper,
  StyledButtonHolder,
  TextFieldWrapper,
} from 'components/common/Form/DateRange/DateRange.styles'
import { ReactComponent as DateRangeIcon } from 'assets/img/date-range-icon.svg'
import 'react-date-range/dist/styles.css'
import 'styles/app/components/date-range.scss'
import './style.scss'
import messages from '../translate'

export const THEME_BASE = 'base-theme'
export const THEME_MYJOB = 'mj-theme'

class DateRangeInput extends Component {
  static defaultProps = {
    disabled: false,
    newEctoStyles: false,
    hideAdornment: false,
    label: '',
    styleTheme: THEME_BASE,
    direction: 'horizontal',
    formControlProps: {},
    inputProps: {},
    dateRangeProps: {},
    onClose: () => {},
    onChange: () => {},
    setIsOpen: () => {},
    range: [
      {
        key: 'selection',
        startDate: subWeeks(new Date(), 1),
        endDate: new Date(),
      },
    ],
  }

  constructor(props) {
    super(props)
    this.state = {
      range: props.range,
      rangePopup: {
        isOpen: false,
        anchor: null,
      },
      width: window.innerWidth,
      monthCount: 2,
      showMonthAndYear: false,
      direction: props.direction,
    }
    this.dateRangeBox = React.createRef()
    this.dateRangeField = React.createRef()
  }

  get formControlProps() {
    const { disabled, styleTheme, formControlProps } = this.props
    const className = `${styleTheme} ${formControlProps.className || ''}`

    return {
      fullWidth: true,
      disabled,
      component: 'div',
      ref: this.dateRangeField,
      onFocus: this.onFocus,
      className,
      ...formControlProps,
    }
  }

  get inputProps() {
    const { inputProps } = this.props

    return {
      readOnly: true,
      id: 'component-error',
      'aria-describedby': 'component-error-text',
      ...inputProps,
    }
  }

  get rangeProps() {
    const { range, monthCount, direction, showMonthAndYear } = this.state
    const { dateRangeProps, locale } = this.props
    const locales = {
      es: datePickerLocaleEs,
      en: datePickerLocaleEn,
    }

    return {
      locale: locales[locale],
      showSelectionPreview: false,
      showDateDisplay: false,
      moveRangeOnFirstSelection: true,
      months: monthCount,
      weekStartsOn: 1,
      monthDisplayFormat: 'MMMM',
      maxDate: new Date(),
      direction,
      ranges: range,
      inputRanges: [],
      staticRanges: this.staticRangeLabel(),
      showMonthAndYearPickers: showMonthAndYear,
      onChange: this.onChangeRange,
      ...dateRangeProps,
    }
  }

  componentDidMount() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    document.addEventListener('click', e => this.onClickRangeOutside(e), false)
    this.props.onChange(this.state.range[0])
  }

  componentDidUpdate(prevProps, prevState) {
    const { range } = this.state

    if (prevState.range[0] !== range[0]) {
      this.props.onChange(range[0])
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('click', this.onClickRangeOutside, false)

    this.dateRangeBox = null
    this.dateRangeField = null
  }

  onClickRangeOutside = event => {
    const { target } = event
    const {
      rangePopup: { isOpen },
    } = this.state

    if (this.dateRangeField && this.dateRangeBox && isOpen) {
      const [dateRangeField, dateRangeBox] = [
        this.dateRangeField.current,
        this.dateRangeBox.current,
      ]

      if (
        !dateRangeBox ||
        (!dateRangeBox.contains(target) && !dateRangeField.contains(target))
      ) {
        this.onCancelRangePopup()
      }
    }
  }

  setRangePopupState = (isOpen, anchor) => {
    this.setState({
      rangePopup: {
        isOpen,
        anchor,
      },
    })
  }

  onResize = () => {
    const { width } = this.state

    if (width <= 1200) {
      this.setState({ monthCount: 2 })
    }

    if (width <= 768) {
      this.setState({
        showMonthAndYear: true,
        direction: 'vertical',
      })
    }

    if (width <= 480) {
      this.setState({ monthCount: 1 })
    }

    this.setState({
      width: window.innerWidth,
    })
  }

  onFocus = e => {
    const {
      rangePopup: { anchor },
    } = this.state
    const { setIsOpen } = this.props

    if (!isEqual(anchor, e.currentTarget)) {
      this.setRangePopupState(true, e.currentTarget)
    }

    setIsOpen(true)
  }

  onCloseRangePopup = () => {
    const { setIsOpen } = this.props

    setIsOpen(false)
    this.setRangePopupState(false, null)
  }

  onCancelRangePopup = () => {
    this.onCloseRangePopup()

    if (!isEqual(this.props.range, this.state.range)) {
      this.setState({
        range: this.props.range,
      })
    }
  }

  onApplyRangePopup = () => {
    this.onCloseRangePopup()
    this.props.onClose(this.state.range[0])
  }

  onChangeRange = data => {
    const { selection } = data

    this.setState({ range: [selection] })
  }

  staticRangeLabel = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const labelSet = [
      {
        label: formatMessage(messages.day_1),
        range: {
          startDate: new Date(),
          endDate: new Date(),
          label: formatMessage(messages.day_1),
        },
      },
      {
        label: formatMessage(messages.days_3),
        range: {
          startDate: subDays(new Date(), 2),
          endDate: new Date(),
          label: formatMessage(messages.days_3),
        },
      },
      {
        label: formatMessage(messages.week_1),
        range: {
          startDate: subWeeks(new Date(), 1),
          endDate: new Date(),
          label: formatMessage(messages.week_1),
        },
      },
      {
        label: formatMessage(messages.weeks_2),
        range: {
          startDate: subWeeks(new Date(), 2),
          endDate: new Date(),
          label: formatMessage(messages.weeks_2),
        },
      },
      {
        label: formatMessage(messages.month_1),
        range: {
          startDate: subMonths(new Date(), 1),
          endDate: new Date(),
          label: formatMessage(messages.month_1),
        },
      },
    ]

    return labelSet.map(item => {
      const { label, range } = item

      return {
        label,
        range: () => range,
        isSelected(range) {
          const definedRange = this.range()

          return (
            isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate)
          )
        },
      }
    })
  }

  getCustomValue = dateDisplay => {
    const { dateRangeProps: { staticRanges } = {} } = this.props
    const { range } = this.state
    if (!isEmpty(staticRanges)) {
      const staticRangeMatch = staticRanges.find(
        ({ startDate, endDate }) =>
          moment(startDate).format(DATE_FORMATS.DEFAULT) ===
            moment(range[0].startDate).format(DATE_FORMATS.DEFAULT) &&
          moment(endDate).format(DATE_FORMATS.DEFAULT) ===
            moment(range[0].endDate).format(DATE_FORMATS.DEFAULT),
      )

      if (staticRangeMatch) {
        return staticRangeMatch.label
      }
    }

    if (
      moment(range[0].startDate).format(DATE_FORMATS.DEFAULT) ===
      moment(range[0].endDate).format(DATE_FORMATS.DEFAULT)
    ) {
      return moment(range[0].startDate).format(dateDisplay)
    }

    return ''
  }

  render() {
    const {
      label,
      styleTheme,
      dateDisplayFormat,
      newEctoStyles,
      hideAdornment,
      minWidth,
    } = this.props
    const {
      range,
      rangePopup: { isOpen, anchor },
    } = this.state
    const dateDisplay = dateDisplayFormat || DATE_FORMATS.DEFAULT
    const value =
      this.getCustomValue(dateDisplay) ||
      `${moment(range[0].startDate).format(dateDisplay)} - ${moment(
        range[0].endDate,
      ).format(dateDisplay)}`
    const PopperComponent = newEctoStyles ? StyledPopper : Popper

    return (
      <FormControl {...this.formControlProps}>
        <TextFieldWrapper>
          <TextField
            {...this.inputProps}
            label={label}
            value={value}
            InputProps={{
              endAdornment: !hideAdornment && (
                <InputAdornment position="end">
                  <DateRangeIcon />
                </InputAdornment>
              ),
              style: {
                width: minWidth ? `${minWidth}px` : `${value.length + 1}ch`,
              },
            }}
          />
        </TextFieldWrapper>
        <PopperComponent
          transition
          open={isOpen}
          anchorEl={anchor}
          placement="bottom"
          className={cn([styleTheme, 'date-range-box'])}>
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} timeout={350}>
              <Paper className="date-range" ref={this.dateRangeBox}>
                <DateRangePicker {...this.rangeProps} />
                <StyledButtonHolder justify="flex-end">
                  {newEctoStyles ? (
                    <>
                      <Button
                        type="secondary"
                        onClick={this.onCancelRangePopup}>
                        {formatMessage(messages.cancel)}
                      </Button>
                      <Button type="primary" onClick={this.onApplyRangePopup}>
                        {formatMessage(messages.setupDate)}
                      </Button>
                    </>
                  ) : (
                    <MUIButton
                      variant="contained"
                      color="primary"
                      size="small"
                      className="date-range-button"
                      onClick={this.onApplyRangePopup}>
                      {formatMessage(messages.setupDate)}
                    </MUIButton>
                  )}
                </StyledButtonHolder>
              </Paper>
            </Grow>
          )}
        </PopperComponent>
      </FormControl>
    )
  }
}

DateRangeInput.propTypes = {
  disabled: T.bool,
  newEctoStyles: T.bool,
  hideAdornment: T.bool,
  label: T.string,
  styleTheme: T.oneOf([THEME_BASE, THEME_MYJOB]),
  direction: T.oneOf(['horizontal', 'vertical']),
  formControlProps: T.object,
  inputProps: T.object,
  dateRangeProps: T.object,
  onChange: T.func,
  onClose: T.func,
  minWidth: T.number,
  range: T.arrayOf(
    T.shape({
      key: T.string,
      startDate: T.instanceOf(Date).isRequired,
      endDate: T.instanceOf(Date).isRequired,
    }),
  ),
  staticRanges: T.arrayOf(T.instanceOf(DateRangeType)),
  dateDisplayFormat: T.string,
  setIsOpen: T.func,
}

export default connect(
  state => ({
    locale: state.getIn(['profile', 'profile', 'locale']),
  }),
  null,
)(injectIntl(DateRangeInput))
